/**
 * Normalize a cohort join code to the canonical XXXX-XXXX format.
 * Handles: lowercase, missing dash, whitespace, punctuation.
 */
export function normalizeJoinCode(raw: string): string {
  const cleaned = raw.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
  if (cleaned.length === 8) return cleaned.slice(0, 4) + '-' + cleaned.slice(4);
  return cleaned;
}
